import {
  Chart,
  ChartCallbackFunction,
  ChartOptions,
  Options,
  PlotOptions,
  SubtitleOptions,
  TitleOptions,
} from 'highcharts';
import React, { useCallback, useEffect, useRef } from 'react';

import { buildDoubleBarChartOptions, BuildLegendProps, BuildTooltipProps } from '../Factories';
import { DoubleBarChartSeries, Row } from '../Factories/buildDoubleBarChartOptions';

const WAIT_ANIMATIONS_TIME = 1000;

export type UseDoubleBarChartReturnValue = {
  options: Options;
  chartRef: React.RefObject<Chart | null>;
  handleChartCallback: (chart: Chart) => void;
};

export type formatterType = (value: number) => string;

export type UseDoubleBarChartOptionsProps = {
  legendOptions?: BuildLegendProps;
  tooltipOptions?: BuildTooltipProps;
  plotOptions?: PlotOptions;
  chart?: ChartOptions;
  subtitle?: SubtitleOptions;
  title?: TitleOptions;
  leftTitle: string;
  rightTitle: string;
  tooltipFormatter: (row: any) => string;
  leftFormatter: formatterType;
  rightFormatter: formatterType;
  series: DoubleBarChartSeries[];
  rows: Row[];
};

const useDoubleBarChart = (props: UseDoubleBarChartOptionsProps): UseDoubleBarChartReturnValue => {
  const options: Options = React.useMemo(() => buildDoubleBarChartOptions({ ...props }), [props]);
  const chartRef = useRef<Chart | null>(null);
  const timeOutRef = React.useRef<ReturnType<typeof setTimeout>>();

  const handleChartCallback = useCallback<ChartCallbackFunction>(
    (newChart: Chart) => {
      chartRef.current = newChart;
    },
    [chartRef],
  );

  useEffect(() => {
    timeOutRef.current = setTimeout(() => {
      if (chartRef.current && chartRef.current.options) {
        chartRef.current.reflow();
      }
    }, WAIT_ANIMATIONS_TIME);

    return () => {
      if (timeOutRef.current) {
        clearTimeout(timeOutRef.current);
      }
    };
  }, [chartRef, options]);

  return { handleChartCallback, options, chartRef };
};

export default useDoubleBarChart;
